import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Input, FormItem, FormValidateStatus } from "melco-ui";
import { Field, useField } from "formik";
import { useIsEmailAvailable } from "melco-shared-logic";
import trim from "lodash-es/trim";
import isEmpty from "lodash-es/isEmpty";

export enum EmailAvailabilityState {
  Unknown = "Unknown",
  Loading = "Loading",
  Taken = "Taken",
  Available = "Available",
}
interface EmailFieldWithAvailabilityCheckProps {
  name: string;
  placeholder?: string;
  label?: string;
}

const EmailFieldWithAvailabilityCheck: React.FC<
  EmailFieldWithAvailabilityCheckProps
> = ({ name, placeholder, label }) => {
  const { t } = useTranslation();
  //const userService = useUserService();
  const isEmailAvailableFn = useIsEmailAvailable();
  const [lastLookup, setLastLookup] = useState<string | undefined>(undefined);

  const [, meta, helpers] = useField(name);
  const [isEmailAvailableField, , isEmailAvailableHelpers] =
    useField("isEmailAvailable");

  const checkEmailAvailability: React.FocusEventHandler<
    HTMLInputElement
  > = async (e) => {
    const eMail = trim(e.target.value);

    if (isEmpty(eMail)) {
      return;
    }

    if (lastLookup === eMail) {
      return;
    }
    setLastLookup(eMail);

    isEmailAvailableHelpers.setValue(EmailAvailabilityState.Loading);

    // const isAvailable = await userService.isEmailAvailable(eMail);
    //  const isEmailAvailableFn = useIsEmailAvailable();
    const isAvailable = await isEmailAvailableFn(eMail)
    isEmailAvailableHelpers.setValue(
      isAvailable
        ? EmailAvailabilityState.Available
        : EmailAvailabilityState.Taken
    );

    helpers.setTouched(true);
  };

  let validateStatus: FormValidateStatus = "";

  if (meta.touched && meta.error) {
    validateStatus = "error";
  } else if (isEmailAvailableField.value === EmailAvailabilityState.Loading) {
    validateStatus = "validating";
  } else if (isEmailAvailableField.value === EmailAvailabilityState.Taken) {
    validateStatus = "error";
  } else if (isEmailAvailableField.value === EmailAvailabilityState.Available) {
    validateStatus = "success";
  }

  // error message
  let help = meta.touched && meta.error && t(meta.error as any);

  if (
    meta.error &&
    meta.error.includes("user_name_exists") &&
    isEmailAvailableField.value === EmailAvailabilityState.Available
  ) {
    // Workaround to fix a temporary inconsistency state in between re-rendering (when the email is available there should be no error message indicating otherwise, not even for a split second)
    help = undefined;
  }

  return (
    <FormItem
      validateStatus={validateStatus}
      hasFeedback={!isEmpty(validateStatus)}
      help={help}
      label={label}
    >
      <Field
        as={Input}
        name={name}
        size="large"
        placeholder={placeholder}
        type="email"
        autoComplete="username"
        onBlur={checkEmailAvailability}
      />
    </FormItem>
  );
};

export default EmailFieldWithAvailabilityCheck;
